import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b2bdf14e: FaireBrandEntity = {
  token: "b_b2bdf14e",
  type: "brand",
  name: "Nest Pretty Things",
  avatarUrl:
    "https://cdn.faire.com/fastly/22ff2a1f8e91b4d8217f2e42b102e53ed66299b52fec8615a977ee456f519d97.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/3846736a9adcab383ba4cca3b33f83eda5772cd3dcdb19fa83142c0ec2a2aa39.png",
  logoUrl:
    "https://cdn.faire.com/fastly/22ff2a1f8e91b4d8217f2e42b102e53ed66299b52fec8615a977ee456f519d97.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/3846736a9adcab383ba4cca3b33f83eda5772cd3dcdb19fa83142c0ec2a2aa39.png",
  location: "Burlington, VT, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 100,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to Nest Pretty Things, where meticulous craftsmanship meets conscious design. Founded by Tamar, Schechner in 2006 our handmade jewelry combines a unique color palette using ethically sourced beads from around the world. \nWe're dedicated to quality that's affordable, sustainable, and plastic-free.\n Beyond adornment, we empower – monthly donations to support women and children in need. \nJoin us in wearing art with heart.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T20:38:32.927Z",
    importedBy: "entity-db-cli",
  },
};
